import Button from "./Button";

export function IndividualDealButton({ onClick }) {
  return (
    <Button
      type="basic"
      label="Individual deal"
      size="small"
      disabled={false}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
